import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { config } from "../Environment";
import useRetryFetch from "../hooks/useRetryFetch";
import useProcess from "../hooks/useProcess";
import { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useEffectOnce } from "../hooks/useEffectOnce";
import LoggerContext from "../context/LoggerProvider";
import useAuth from "../hooks/useAuth";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { PageLoader } from "./ui/page-loader";

function EntryActivity() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const retryFetch = useRetryFetch();
  const { startProcess, resumeProcess } = useProcess();
  const { auth, user } = useAuth();
  const { Logger } = useContext(LoggerContext);
  const { t } = useTranslation();
  const [authenticated, setAuthenticated] = useState(auth?.email);

  const workflowId = searchParams.get("wid");
  const processId = searchParams.get("pid");

  async function continueProcess(processId) {
    await resumeProcess({
      processId,
    });
  }

  async function runPrescription(prescriptionId) {
    await startProcess({
      prescriptionId,
    });
  }

  // async function loadPrescriptionMetadata(id) {
  //   if (id) {
  //     console.log(`fetching activity metadata for id: ${id}`);
  //     const activityMetadataResponse = await retryFetch(
  //       `${config.API_BASE}/api/prescriptions/${id}/metadata`,
  //       {
  //         credentials: "include",
  //       }
  //     );
  //     if (activityMetadataResponse.ok) {
  //       console.log(`got activity metadata for id: ${id}`);
  //       const activityMetadata = await activityMetadataResponse.json();
  //       // setActivityInfo(activityMetadata);
  //       // setAuthorInfo(activityMetadata.fiUser);
  //     }
  //   }
  // }

  // async function init() {
  //   await loadPrescriptionMetadata(workflowId);
  // }

  useEffectOnce(() => {
    // init();
    const email = auth?.email ?? null;
    if (email) {
      setTimeout(() => {
        if (processId) {
          console.log(`EntryActivity.jsx continuing process ${processId}`);
          continueProcess(processId);
        } else if (workflowId) {
          console.log(`EntryActivity.jsx starting workflow ${workflowId}`);
          runPrescription(workflowId);
        } else {
          navigate("/portal");
        }
      }, 1000);
    }
  }, []);

  function renderAuthenticated() {
    return (
        <PageLoader fullScreen />
    );
  }

  function renderNotAuthenticated() {
    return (
      <Card className="center">
        <CardContent side="bottom">
          <CardHeader>
            <CardTitle>You are signed out</CardTitle>
          </CardHeader>
<p style={{"margin":"5px"}}>Thank you for using ClaryNext.</p>
<p style={{"margin":"5px"}}><strong>Where to go from here?</strong></p>
<p style={{"margin":"5px"}}>Sign in to continue to the activity.</p>
<p style={{"margin":"5px"}}>Visit our website:</p>
<p style={{"margin":"5px"}}><a href="https://clarynext.com" style={{"color":"blue","textDecoration":"underline"}}>ClaryNext.com</a></p>
        </CardContent>
      </Card>
    );
  }

  if (authenticated) {
    return renderAuthenticated();
  } else {
    return renderNotAuthenticated();
  }

}

export default EntryActivity;
